export default __webpack_public_path__ + "static/media/sea2demo.00b106d5.png";